export default "__VITE_ASSET__DAC_4SXi__"